import React, { forwardRef, useEffect, useState } from "react";
import RadioButton from "../../../generic/radioButton";
import { IListObj } from "../../../types/genericTypes";
const accTypes: Array<IListObj> = [
  { value: "trading+demat", display: "Trading+Demat" },
  { value: "demat", display: "Demat" },
  { value: "trading", display: "Trading" },
];
export const AccounTypeRadio = forwardRef((props: any, ref: any) => {
  const [accType, setAccType] = useState<any>(accTypes[0].value);

  useEffect(() => {
    props.setAccountType(accType);
  }, [accType]);

  useEffect(() => {
    if (props.onlyTrading && props.onlyTrading === 1)
      setAccType(accTypes[2].value);
    else setAccType(accTypes[0].value);
  }, [props.onlyTrading]);

  return (
    <>
      <div className="CheckboxWrap space-mb-1">
        <div>
          <h6>Options</h6>
        </div>
        <div className="payment-radio nominationRadio">
          <div className="display-flex tradeDemat">
            {(props.onlyTrading ? props.onlyTrading !== 1 : true) && (
              <div className="radioBtn_wrap">
                <RadioButton
                  list={accTypes[0]}
                  name="accTypeNomin"
                  onChange={() => {
                    setAccType(accTypes[0].value);
                  }}
                  selected={accType}
                  disabled={props.disabled}
                />
              </div>
            )}

            {(props.onlyTrading ? props.onlyTrading !== 1 : true) && (
              <div className="radioBtn_wrap">
                <RadioButton
                  list={accTypes[1]}
                  name="accTypeNomin"
                  onChange={() => {
                    setAccType(accTypes[1].value);
                  }}
                  selected={accType}
                  disabled={props.disabled}
                />
              </div>
            )}

            <div className="radioBtn_wrap">
              <RadioButton
                list={accTypes[2]}
                name="accTypeNomin"
                onChange={() => {
                  setAccType(accTypes[2].value);
                }}
                selected={accType}
                disabled={props.disabled}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
});
